import React, { Component } from 'react';
import config from 'react-global-configuration';

import Select from 'react-select';
import InputMask from 'react-input-mask';

import { Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import getLocale from '../../../i18n/getLocale';

class DrowsinessScheduleResultTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      id: this.props.drowsiness_schedule_id,
      horas_registradas: null,
      hours_registred_active: 0,
      days_period_active: 0,
      jornadas_horas: null,
      jornadas_dias: null,
      bases_array: null,
      roles_array: null,
      groups_array: null,
      aircraft_models_array: null,
      designations_array: null,
      hours_registred_list: [],
      bases_list: [],
      roles_list: [],
      designations_list: [],
      aircraft_models_list: [],
      groups_list: [],
      hours_registred: null,
      days_period: null,
    };

    this.searchReports = this.searchReports.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }


  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.drowsiness_schedule_id !== 'undefined' && typeof newProps.drowsiness_schedule_reports !== 'undefined') {
      this.setState({
        id: newProps.drowsiness_schedule_id,
        applicability_id: newProps.drowsiness_schedule_applicability,
        hours_registred_list: newProps.drowsiness_schedule_reports.hours_registred_list,
        bases_list: newProps.drowsiness_schedule_reports.bases_list,
        roles_list: newProps.drowsiness_schedule_reports.roles_list,
        designations_list: newProps.drowsiness_schedule_reports.designations_list,
        aircraft_models_list: newProps.drowsiness_schedule_reports.aircraft_models_list,
        groups_list: newProps.drowsiness_schedule_reports.groups_list,
      });
    }
  }

  searchReports(event) {
    event.preventDefault();
    var self = this;
    self.props.handleAlert('', '', 'open');
    var datasave = {
      hours_registred: this.state.hours_registred,
      days_period: this.state.days_period,
      bases: this.state.bases,
      bases_list: this.state.bases_list,
      roles: this.state.roles,
      roles_list: this.state.roles_list,
      designations: this.state.designations,
      designations_list: this.state.designations_list,
      aircraft_models: this.state.aircraft_models,
      aircraft_models_list: this.state.aircraft_models_list,
      groups: this.state.groups,
      groups_list: this.state.groups_list,
      drowsiness_schedule_id: this.state.id,
    };

    var header = self.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/sonolencia/relatorio', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({horas_registradas: responseJson.data.horas_registradas});
          self.setState({jornadas_dias: responseJson.data.jornadas_dias});
          self.setState({jornadas_horas: responseJson.data.jornadas_horas});
          self.setState({bases_array: responseJson.data.bases_array});
          self.setState({roles_array: responseJson.data.roles_array});
          self.setState({groups_array: responseJson.data.groups_array});
          self.setState({aircraft_models_array: responseJson.data.aircraft_models_array});
          self.setState({designations_array: responseJson.data.designations_array});
          self.setState({percent_result: responseJson.data.percent_result});
          self.setState({percent_result_global: responseJson.data.percent_result_global});
          self.setState({media_time_report: responseJson.data.media_time_report});
          self.setState({reports: responseJson.data.reports});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <form onSubmit={self.searchReports}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.PeriodoDeJornada}:</label>
          <Select
            className="form-field-name"
            name="hours_registred"
            value={this.state.hours_registred}
            searchable={true}
            placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarPeriodoDeJornada}
            multi={true}
            onChange={this.handleSelectChangeMulti.bind(this, 'hours_registred')}
            options={this.state.hours_registred_list}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.DiasDeJornada}:</label>
          <input type="text" name="days_period" className="form-control" placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.DiasDeJornada} value={this.state.days_period} onChange={this.handleChange.bind(this, 'days_period')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Bases}:</label>
          <Select
            className="form-field-name"
            name="bases"
            value={this.state.bases}
            searchable={true}
            placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarBases}
            multi={true}
            onChange={this.handleSelectChangeMulti.bind(this, 'bases')}
            options={this.state.bases_list}
          />
        </div>
      </div>
      {this.state.applicability_id === 1 || this.state.applicability_id === 4 ?
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Designacoes}:</label>
            <Select
              className="form-field-name"
              name="designations"
              value={this.state.designations}
              searchable={true}
              placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarDesignacoes}
              multi={true}
              onChange={this.handleSelectChangeMulti.bind(this, 'designations')}
              options={this.state.designations_list}
            />
          </div>
        </div>
        : this.state.applicability_id === 2 ?
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Funcoes}:</label>
            <Select
              className="form-field-name"
              name="roles"
              value={this.state.roles}
              searchable={true}
              placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarFuncoes}
              multi={true}
              onChange={this.handleSelectChangeMulti.bind(this, 'roles')}
              options={this.state.roles_list}
            />
          </div>
        </div>
        : this.state.applicability_id === 3 ?
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Cargos}:</label>
            <Select
              className="form-field-name"
              name="roles"
              value={this.state.roles}
              searchable={true}
              placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarCargos}
              multi={true}
              onChange={this.handleSelectChangeMulti.bind(this, 'roles')}
              options={this.state.roles_list}
            />
          </div>
        </div>
        :
        ''
      }
    </div>
    {this.state.applicability_id === 1 || this.state.applicability_id === 4 ?
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Frotas}:</label>
            <Select
              className="form-field-name"
              name="aircraft_models"
              value={this.state.aircraft_models}
              searchable={true}
              placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarFrotas}
              multi={true}
              onChange={this.handleSelectChangeMulti.bind(this, 'aircraft_models')}
              options={this.state.aircraft_models_list}
            />
          </div>
        </div>
      </div>
      : this.state.applicability_id === 2 ?
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Grupos}:</label>
            <Select
              className="form-field-name"
              name="groups"
              value={this.state.groups}
              searchable={true}
              placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarGrupos}
              multi={true}
              onChange={this.handleSelectChangeMulti.bind(this, 'groups')}
              options={this.state.groups_list}
            />
          </div>
        </div>
      </div>
      :
      ''
    }
    <div>
      <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.botaoProcurarRelatorios}</button>
    </div>
  </form>
  <hr/>
  {self.state.horas_registradas !== null  ?
      <div>
        <h3>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloPontosPorHorarioDeResposta}</h3>
        <hr/>
        <p>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoPercentualDeAdesaoParcial} {self.state.percent_result}</p>
        <p>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoPercentualDeAdesaoGlobal} {self.state.percent_result_global}</p>
        <p>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoTempoMedioDeResposta} {self.state.media_time_report}</p>
        <p>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoTotalRespostas} {self.state.reports}</p>
        <hr/>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloCadaHorarioDeResposta}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.PeriodoHoras}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.Media}
              </th>
            </tr>
          </thead>
          <tbody id="horas">
            {self.state.horas_registradas !== null  ?

              Object.keys(self.state.horas_registradas.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.horas_registradas.table[k].total}
                    </td>
                    <td>
                      {self.state.horas_registradas.table[k].points}
                    </td>
                    <td>
                      {self.state.horas_registradas.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.horas_registradas.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.horas_registradas.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.horas_registradas.names[k].name} stroke={self.state.horas_registradas.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.horas_registradas.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.horas_registradas.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.horas_registradas.names[k].name} stroke={self.state.horas_registradas.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.horas_registradas.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.horas_registradas.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.horas_registradas.names[k].name} stroke={self.state.horas_registradas.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.jornadas_horas!== null ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloPontosPorPeriodoDeJornada}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.PeriodoHoras}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.Media}
              </th>
            </tr>
          </thead>
          <tbody id="periodo">
            {self.state.jornadas_horas!== null ?
              Object.keys(self.state.jornadas_horas.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.jornadas_horas.table[k].total}
                    </td>
                    <td>
                      {self.state.jornadas_horas.table[k].points}
                    </td>
                    <td>
                      {self.state.jornadas_horas.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.jornadas_horas.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.jornadas_horas.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.jornadas_horas.names[k].name} stroke={self.state.jornadas_horas.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.jornadas_horas.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.jornadas_horas.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.jornadas_horas.names[k].name} stroke={self.state.jornadas_horas.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.jornadas_horas.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.jornadas_horas.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.jornadas_horas.names[k].name} stroke={self.state.jornadas_horas.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.jornadas_dias!== null ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloPontosPorDiasDeJornada}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.PeriodoDias}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.Media}
              </th>
            </tr>
          </thead>
          <tbody id="dias">
            {self.state.jornadas_dias!== null ?
              Object.keys(self.state.jornadas_dias.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.jornadas_dias.table[k].total}
                    </td>
                    <td>
                      {self.state.jornadas_dias.table[k].points}
                    </td>
                    <td>
                      {self.state.jornadas_dias.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.jornadas_dias.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.jornadas_dias.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.jornadas_dias.names[k].name} stroke={self.state.jornadas_dias.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.jornadas_dias.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.jornadas_dias.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.jornadas_dias.names[k].name} stroke={self.state.jornadas_dias.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.jornadas_dias.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.jornadas_dias.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.jornadas_dias.names[k].name} stroke={self.state.jornadas_dias.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.bases_array!== null ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloBases}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Base}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Media}
              </th>
            </tr>
          </thead>
          <tbody id="bases">
            {self.state.bases_array!== null ?
              Object.keys(self.state.bases_array.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.bases_array.table[k].total}
                    </td>
                    <td>
                      {self.state.bases_array.table[k].points}
                    </td>
                    <td>
                      {self.state.bases_array.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.bases_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.bases_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.bases_array.names[k].name} stroke={self.state.bases_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.bases_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.bases_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.bases_array.names[k].name} stroke={self.state.bases_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.bases_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.bases_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.bases_array.names[k].name} stroke={self.state.bases_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.roles_array!== null && self.state.roles_array !== 'undefined' ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloFuncoes}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Funcao}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Media}
              </th>
            </tr>
          </thead>
          <tbody id="funcoes">
            {self.state.roles_array!== null && self.state.roles_array !== 'undefined' ?
              Object.keys(self.state.roles_array.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.roles_array.table[k].total}
                    </td>
                    <td>
                      {self.state.roles_array.table[k].points}
                    </td>
                    <td>
                      {self.state.roles_array.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.roles_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.roles_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.roles_array.names[k].name} stroke={self.state.roles_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.roles_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.roles_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.roles_array.names[k].name} stroke={self.state.roles_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.roles_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.roles_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.roles_array.names[k].name} stroke={self.state.roles_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.groups_array!== null && self.state.groups_array !== 'undefined' ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloGrupos}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Grupo}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Media}
              </th>
            </tr>
          </thead>
          <tbody id="grupos">
            {self.state.groups_array!== null && self.state.groups_array !== 'undefined' ?
              Object.keys(self.state.groups_array.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.groups_array.table[k].total}
                    </td>
                    <td>
                      {self.state.groups_array.table[k].points}
                    </td>
                    <td>
                      {self.state.groups_array.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.groups_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.groups_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.groups_array.names[k].name} stroke={self.state.groups_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.groups_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.groups_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.groups_array.names[k].name} stroke={self.state.groups_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.groups_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.groups_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.groups_array.names[k].name} stroke={self.state.groups_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.designations_array!== null && self.state.designations_array !== 'undefined' ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloDesignacoes}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Designacao}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Media}
              </th>
            </tr>
          </thead>
          <tbody id="designacoes">
            {self.state.designations_array!== null ?
              Object.keys(self.state.designations_array.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.designations_array.table[k].total}
                    </td>
                    <td>
                      {self.state.designations_array.table[k].points}
                    </td>
                    <td>
                      {self.state.designations_array.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.designations_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.designations_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.designations_array.names[k].name} stroke={self.state.designations_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.designations_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.designations_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.designations_array.names[k].name} stroke={self.state.designations_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.designations_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.designations_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.designations_array.names[k].name} stroke={self.state.designations_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
  {self.state.aircraft_models_array!== null && self.state.aircraft_models_array !== 'undefined' ?
      <div>
        <h4>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloFrotas}</h4>
        <hr/>
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Frota}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Total}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Pontos}
              </th>
              <th>
                {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Media}
              </th>
            </tr>
          </thead>
          <tbody id="frotas">
            {self.state.aircraft_models_array!== null ?
              Object.keys(self.state.aircraft_models_array.table).map(function(k) {
                return (
                  <tr>
                    <td>
                      {k}
                    </td>
                    <td>
                      {self.state.aircraft_models_array.table[k].total}
                    </td>
                    <td>
                      {self.state.aircraft_models_array.table[k].points}
                    </td>
                    <td>
                      {self.state.aircraft_models_array.table[k].media}
                    </td>
                  </tr>
                );
              })
            : ""}
          </tbody>
        </table>
        <hr/>
        <div className="hidden-sm hidden-xs">
          <LineChart width={890} height={400} data={self.state.aircraft_models_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.aircraft_models_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.aircraft_models_array.names[k].name} stroke={self.state.aircraft_models_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-sm-inline-block">
          <LineChart width={690} height={300} data={self.state.aircraft_models_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.aircraft_models_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.aircraft_models_array.names[k].name} stroke={self.state.aircraft_models_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <div className="visible-xs-inline-block">
          <LineChart width={280} height={400} data={self.state.aircraft_models_array.horas}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis dataKey="Média"/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            {Object.keys(self.state.aircraft_models_array.names).map(function(k) {
              return (
               <Line type="monotone" dataKey={self.state.aircraft_models_array.names[k].name} stroke={self.state.aircraft_models_array.names[k].color} activeDot={{r: 8}}/>
              );
            })}
          </LineChart>
        </div>
        <hr/>
      </div>
  : ""}
</div>
    );
  }
}

export default DrowsinessScheduleResultTab;



// WEBPACK FOOTER //
// ./src/Components/DrowsinessSchedules/Elements/DrowsinessScheduleResultTab.js